<template>
  <div>
    <v-expansion-panels class="hidden-md-and-up" pa-0>
      <v-expansion-panel>
        <v-expansion-panel-header expand-icon="mdi-menu" flat>
          <div class="d-flex">
            <a href="/" class="router">
              <v-img
                alt="Logotipo do Peja Bauru escrito na cor laranja"
                class="shrink"
                contain
                :src="require('@/assets/svg/logo.svg')"
                transition="scale-transition"
                height="50"
                width="150"
              />
            </a>
          </div>
        </v-expansion-panel-header>
        <v-divider />

        <v-expansion-panel-content>
          <v-card class="mx-auto" elevation="0">
            <v-card-text>
              <router-link to="/about" class="router">
                <span class="btnText">Sobre</span>
              </router-link>
            </v-card-text>
          </v-card>

          <v-card class="mx-auto" elevation="0">
            <v-card-text>
              <router-link to="/goals" class="router">
                <span class="btnText">Objetivos</span>
              </router-link>
            </v-card-text>
          </v-card>

          <v-card class="mx-auto" elevation="0">
            <v-card-text>
              <router-link to="/team" class="router">
                <span class="btnText">Equipe</span>
              </router-link>
            </v-card-text>
          </v-card>

          <v-card class="mx-auto" elevation="0">
            <v-card-text>
              <router-link to="/faq" class="router">
                <span class="btnText">FAQ</span>
              </router-link>
            </v-card-text>
          </v-card>

          <v-card v-if="!isLogged" class="mx-auto" elevation="0">
            <v-card-text class="text-center">
              <v-btn
                :to="{ name: 'Login' }"
                outlined
                rounded
                large
                color="primary"
              >
                <v-icon>mdi-account</v-icon>
                <span class="ml-2">Entrar</span>
              </v-btn>
            </v-card-text>
          </v-card>

          <v-card v-if="isLogged" class="mx-auto" elevation="0">
            <v-card-text>
              <router-link to="/account" class="router">
                <span class="btnText">Meu Perfil</span>
              </router-link>
            </v-card-text>
          </v-card>

          <v-card v-if="isLogged" class="mx-auto" elevation="0">
            <v-card-text>
              <router-link to="/dashboard" class="router">
                <span class="btnText">Dashboard</span>
              </router-link>
            </v-card-text>
          </v-card>

          <v-card v-if="isLogged" class="mx-auto" elevation="0">
            <v-card-text class="text-center">
              <v-btn outlined rounded large color="primary" @click="logoutUser">
                <v-icon>mdi-account</v-icon>
                <span class="ml-2">Sair</span>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-app-bar app color="white" dark height="90" class="hidden-sm-and-down">
      <div class="d-flex">
        <a href="/" class="router">
          <v-img
            alt="Logotipo do Peja Bauru escrito na cor laranja"
            class="shrink"
            contain
            :src="require('@/assets/svg/logo.svg')"
            transition="scale-transition"
            height="50"
            width="150"
          />
        </a>
      </div>

      <v-spacer />

      <v-btn to="/about" color="primary" text height="100%"> Saiba mais </v-btn>

      <v-btn to="/goals" color="primary" text height="100%"> Objetivos </v-btn>

      <v-btn to="/team" color="primary" text height="100%"> Equipe </v-btn>

      <v-btn to="/faq" color="primary" text height="100%"> FAQ </v-btn>

      <v-menu
        open-on-hover
        bottom
        offset-y
        transition="scroll-y-transition"
        style="z-index: 999999 !important"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" color="primary" text height="100%" v-on="on">
            <v-icon>mdi-glasses</v-icon>
            <span class="ml-2">Acessibilidade</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="zoomIn">
            <v-list-item-title>Aumentar texto</v-list-item-title>
          </v-list-item>
          <v-list-item @click="zoomOut">
            <v-list-item-title>Diminuir texto</v-list-item-title>
          </v-list-item>
          <v-list-item @click="setGrayScale">
            <v-list-item-title>{{
              !grayScale ? 'Escala de Cinza' : 'Retornar cores'
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        v-if="!isLogged"
        :to="{ name: 'Login' }"
        outlined
        rounded
        large
        color="primary"
      >
        <v-icon>mdi-account</v-icon>
        <span class="ml-2">Entrar</span>
      </v-btn>
      <v-menu
        v-if="isLogged"
        open-on-hover
        bottom
        offset-y
        transition="scroll-y-transition"
        style="z-index: 999999 !important"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            rounded
            large
            color="primary"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-account</v-icon>
            <span class="ml-2">Perfil</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/account">
            <v-list-item-title>Meu perfil</v-list-item-title>
          </v-list-item>
          <v-list-item to="/dashboard">
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logoutUser">
            <v-list-item-title>Sair</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { logout } from '@/services/auth';

export default {
  name: 'Login',
  data() {
    return {
      grayScale: false,
    };
  },
  computed: {
    ...mapGetters({ isLogged: 'auth/getIsLogged' }),
  },
  methods: {
    logoutUser() {
      logout();
    },
    zoomIn() {
      if (document.body.style.zoom === '100%' || !document.body.style.zoom) {
        document.body.style.zoom = '125%';
      } else if (document.body.style.zoom !== '125%') {
        document.body.style.zoom = '100%';
      }
    },
    zoomOut() {
      if (document.body.style.zoom === '125%') {
        document.body.style.zoom = '100%';
      } else {
        document.body.style.zoom = '90%';
      }
    },
    setGrayScale() {
      this.grayScale = !this.grayScale;
      this.$emit('grayScale', this.grayScale);
    },
  },
};
</script>

<style>
a:link {
  text-decoration: none;
}

.btnText {
  font-weight: 600;
  font-size: 1.1em;
}
</style>
